var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:({
    content: _vm.tooltipText,
    show: _vm.showTooltip,
    trigger: 'manual',
    placement: 'left',
  }),expression:"{\n    content: tooltipText,\n    show: showTooltip,\n    trigger: 'manual',\n    placement: 'left',\n  }"}],staticClass:"kd-text-layer",style:(_vm.parentStyle),attrs:{"disabled":false},on:{"click":_vm.onWrapperClick}},[_c('div',{ref:"text",staticClass:"kd-text-layer__text",style:({
        fontSize: _vm.fontSizeCss,
        fontFamily: _vm.fontFamilyCss,
        fontWeight: _vm.fontWeight,
        fontStyle: _vm.fontStyle,
        textAlign: _vm.textAlignCss,
        lineHeight: _vm.lineHeightCss,
        color: _vm.color,
      }),attrs:{"contenteditable":"","spellcheck":"false"},domProps:{"innerHTML":_vm._s(_vm.text)},on:{"input":function($event){_vm.textEdited($event)},"textinput":function($event){_vm.textEdited($event)},"paste":function($event){_vm.onPaste($event)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }